import Page from "webPage/Page";
import VideoModal from "modal/VideoModal";

Page.register("page-template-process", () => {
    $('body').on('click', '.js-process-item-link', function(){
        $('html, body').animate({
            scrollTop: ($($(this).attr('href')).offset().top)
        },500);

        return false;
    }).on('click', '.js-play-video', function(){
        let id = $(this).attr('data-video-id');
        let provider = parseInt($(this).attr('data-provider'));
        let modal = new VideoModal(id, provider);
        modal.show();

        return false;
    });
});
